import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from "react";
import { Button, Spin, Switch } from "antd";
import { Col, Row } from "react-bootstrap";
import ToggleMenu from "../../Img/burger_menu.svg";
import DarkIcon from "../../Img/dark-btn.svg";
import LightIcon from "../../Img/light-btn.svg";
import NotificationIcon from "../../Img/notification.svg";
import UsFlag from "../../Img/us.svg";
import IndiaFlag from "../../Img/india.svg";
import GermanFlag from "../../Img/german.svg";
import FrenchFlag from "../../Img/french.svg";
import SelectArrow from "../../Img/select-arrow.svg";
import Close from "../../Img/Close.svg";
import PatientIcon from "../../Img/patient-icon.svg";
import { Dropdown } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ThemeContext } from "../../contexts/theme-context";
import { useDispatch, useSelector } from "react-redux";
import { logoutAction } from "redux/reducers/auths.slice";
import jsonp from "fetch-jsonp";
import qs from "qs";
import { Select } from "antd";
import Cookies from "js-cookie";
import {
  clearData,
  getGlobalSearch,
  setGlobalSearchData,
  setGlobalSearchFileValue,
  setPatientEdit,
} from "redux/reducers/SearchPanel/globalSearch.slice";
import {
  setIvfIdListData,
  setSelectedPatient,
} from "redux/reducers/common.slice";
import _ from "lodash";
import {
  getLocationData,
  getPermissionLocationWise,
  setModuleList,
  setSelectedLocation,
} from "redux/reducers/Role/role.slice";
import { CloseOutlined } from "@ant-design/icons";
import { sendDataToSocket } from "socket/SocketComponent";
import { setLocationOptions } from "redux/reducers/Dashboard/dashboard.slice";
import ChangePasswordModal from "Components/Pages/ChangePassword/ChangePasswordModal";
import {
  clearNotification,
  getNotificationList,
  notificationSubscribe,
  notificationUnSubscribe,
  readAllNotification,
  readSingleNotification,
  setAllowNotificationToggle,
  setNotificationPermissionDialogVisible,
} from "redux/reducers/Notification/NotificationSlice";
import moment from "moment";
import { formatDateToDDMMYYYY } from "utils/CommonFunctions";
import NotificationPermissionDialog from "./Notification/NotificationPermissionDialog";

const countryWiseLanguage = [
  {
    key: "1",
    label: (
      <span className="language_items">
        <img src={UsFlag} alt="" /> English
      </span>
    ),
  },
  {
    key: "2",
    label: (
      <span className="language_items">
        <img src={IndiaFlag} alt="" /> Hindi
      </span>
    ),
  },
  {
    key: "3",
    label: (
      <span className="language_items">
        <img src={GermanFlag} alt="" /> German
      </span>
    ),
  },
  {
    key: "4",
    label: (
      <span className="language_items">
        <img src={FrenchFlag} alt="" /> French
      </span>
    ),
  },
];

let timeout;
let currentValue;
const fetch = (value, callback) => {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;
  const fake = () => {
    const str = qs.stringify({
      code: "utf-8",
      q: value,
    });
    jsonp(`https://suggest.taobao.com/sug?${str}`)
      .then((response) => response.json())
      .then((d) => {
        if (currentValue === value) {
          const { result } = d;
          const data = result.map((item) => ({
            value: item[0],
            text: item[0],
          }));
          callback(data);
        }
      });
  };
  if (value) {
    timeout = setTimeout(fake, 300);
  } else {
    callback([]);
  }
};

export default function Header({ collapsed, setCollapsed, props }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { embryologyRedirect } = useSelector(
    ({ embryologyData }) => embryologyData
  );

  const [notificationModal, setNotificationModal] = useState(false);
  const {
    locationData,
    isLocationLoading,
    selectedLocation,
    permissionLocationWiseLoading,
    moduleList,
    userType,
  } = useSelector(({ role }) => role);
  let UserData;
  let UserPreferences = localStorage.getItem("UserPreferences");
  if (UserPreferences) {
    UserData = UserPreferences = JSON.parse(window.atob(UserPreferences));
  }
  const {
    globalSearchData,
    globalSearchLoading,
    globalSearchFileValue,
    patientEdit,
  } = useSelector(({ globalSearch }) => globalSearch);
  const { patientLoading } = useSelector(
    ({ patientRegistration }) => patientRegistration
  );
  const { patientBasicLoading } = useSelector(
    ({ patientBasicHistory }) => patientBasicHistory
  );
  const [locationList, setLocationList] = useState([]);
  const [data, setData] = useState([]);
  const [selectLocation, setSelectLocation] = useState("");
  const [searchVal, setSearchVal] = useState(null);
  const [isShowChangePasswordModal, setIsShowChangePasswordModal] =
    useState(false);

  const {
    notificationList,
    notificationPageLimit,
    notificationCurrentPage,
    allowNotificationToggle,
    notificationPermissionDialogVisible,
  } = useSelector(({ notification }) => notification);

  const fetchNotificationList = useCallback(() => {
    dispatch(
      getNotificationList({
        location_id: selectedLocation,
        start: notificationCurrentPage,
        limit: notificationPageLimit,
      })
    );
  }, [
    dispatch,
    selectedLocation,
    notificationPageLimit,
    notificationCurrentPage,
  ]);

  useEffect(() => {
    locationData.length === 0 && dispatch(getLocationData());

    if (selectedLocation) {
      fetchNotificationList();
    }
  }, [dispatch, selectedLocation]);

  useEffect(() => {
    if (locationData?.length > 0) {
      const locationListData =
        locationData
          ?.filter((location) => {
            return UserPreferences?.other === false
              ? location
              : location?.deleted === false && location;
          })
          .map((location) => {
            return {
              value: location.location_id,
              label: location.location_name,
            };
          }) || [];
      if (selectedLocation) {
        if (locationListData.find((item) => item.value === selectedLocation)) {
          setSelectLocation(selectedLocation);
          moduleList.length === 0 &&
            dispatch(getPermissionLocationWise(selectedLocation));
        } else {
          navigate("/user-select-location");
        }
      } else if (selectedLocation == null) {
        navigate("/user-select-location");
      }
      setLocationList(locationListData);
      dispatch(setLocationOptions(locationListData));
    }
  }, [dispatch, navigate, locationData]);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  const { theme, setTheme } = useContext(ThemeContext);

  const handleThemeChange = () => {
    const isCurrentDark = theme === "dark";
    setTheme(isCurrentDark ? "light" : "dark");
    localStorage.setItem("default-theme", isCurrentDark ? "light" : "dark");
  };

  const userDropDown = [
    {
      key: "Change Password",
      label: (
        <Button
          className={`bg-transparent border-0 p-0 h-auto shadow-none text-${
            theme === "dark" ? "light" : "dark"
          }`}
          onClick={() => setIsShowChangePasswordModal(true)}
        >
          Change Password
        </Button>
      ),
    },
    {
      key: "Logout",
      label: (
        <Link
          to="/login"
          className="language_items"
          onClick={() => {
            dispatch(clearData());
            dispatch(setSelectedPatient({}));
            localStorage.removeItem("UserPreferences");
            dispatch(setSelectedLocation(""));
            localStorage.removeItem("userLocation");
            dispatch(logoutAction());
            dispatch(setModuleList([]));
            Cookies.remove("notificationPermissionNotAllow");
          }}
        >
          Logout
        </Link>
      ),
    },
    {
      key: "Allow Permission",
      label: (
        <div
          className="d-flex p-menuitem-link justify-content-between align-items-center switch-input gap-3"
          onClick={(e) => e.stopPropagation()}
        >
          <span className="">Allow Permission</span>

          <Switch
            value={allowNotificationToggle}
            onChange={(value) => {
              dispatch(setAllowNotificationToggle(value));

              if (!!value) {
                dispatch(
                  notificationSubscribe({
                    location_id: selectedLocation,
                  })
                );
              } else {
                dispatch(
                  notificationUnSubscribe({
                    location_id: selectedLocation,
                  })
                );
                Cookies.set("notificationPermissionNotAllow", true, {
                  expires: 12,
                });
              }
            }}
          />
        </div>
      ),
    },
  ];
  const handleSearch = useCallback(
    (newValue, selectedLocation) => {
      if (newValue && selectedLocation) {
        dispatch(
          getGlobalSearch({
            patient_name: newValue,
            location_id: selectedLocation,
            patient_reg_id: Object.keys(patientEdit).length
              ? patientEdit._id
              : null,
          })
        );
      }
      if (!newValue) {
        dispatch(setGlobalSearchData([]));
      }
    },
    [dispatch]
  );
  const globalSearchTextChange = React.useCallback(
    _.debounce(handleSearch, 800),
    []
  );
  const handleChange = (newValue, globalData) => {
    const patientDetail = globalData?.find(
      (patient) => patient?._id === newValue || null
    );

    if (patientDetail) {
      dispatch(setSelectedPatient(patientDetail));
      if (patientDetail?.ivf_flow_data.length > 0) {
        const ivfListId = patientDetail?.ivf_flow_data?.map((item) => ({
          ...item,
          value: item._id,
          label: item.ivf_id,
        }));
        dispatch(setSelectedPatient(patientDetail));
      }
    }
    dispatch(setPatientEdit({}));
    dispatch(
      setGlobalSearchFileValue({
        _id: patientDetail._id,
        patient_full_name: patientDetail.patient_full_name,
      })
    );
  };

  useEffect(() => {
    setData(globalSearchData);
    if (Object.keys(patientEdit).length)
      handleChange(patientEdit._id, globalSearchData);
  }, [globalSearchData]);

  useEffect(() => {
    if (Object.keys(patientEdit).length) {
      setSearchVal(patientEdit.patient_full_name);
      globalSearchTextChange(
        patientEdit.patient_full_name,
        patientEdit.location_id
      );
    }
  }, [patientEdit]);

  useEffect(() => {
    if (Object.keys(globalSearchFileValue)?.length > 0) {
      setSearchVal(globalSearchFileValue.patient_full_name);
    } else {
      setSearchVal(null);
    }
  }, [globalSearchFileValue]);
  const handleClearSearch = () => {
    navigate("/");
    dispatch(setSelectedPatient({}));
    dispatch(setIvfIdListData([]));
    dispatch(clearData());
  };
  const getModuleName = useMemo(() => {
    const matchModule = moduleList.find(
      (item) => item.module_name === location.pathname
    );
    let currentModule = matchModule?.module_actual_name || "";
    if (location.pathname === "/") {
      currentModule = "Dashboard";
    }
    return currentModule || "";
  }, [location.pathname, moduleList]);

  const handleLocationChange = (value) => {
    if (UserPreferences?.other) {
      dispatch(clearData());
      dispatch(setSelectedPatient({}));
    }

    localStorage.setItem(
      "userLocation",
      window.btoa(JSON.stringify(value || null))
    );
    sendDataToSocket("JUR", {
      room_id: value || null,
    });
    dispatch(setSelectedLocation(value || null));
    dispatch(getPermissionLocationWise(value || null));
    setSelectLocation(value || null);
  };

  const handleReadAllNotification = () => {
    if (notificationList?.unreadCount) {
      dispatch(
        readAllNotification({
          location_id: selectedLocation,
        })
      )
        .then(() => {
          fetchNotificationList();
        })
        .catch((error) => {
          console.error("Error marking notifications as read:", error);
        });
    } else {
      console.log("No unread notifications to mark as read");
    }
  };

  const handleClearNotification = () => {
    if (notificationList?.list?.length > 0) {
      dispatch(
        clearNotification({
          location_id: selectedLocation,
        })
      );
    }
  };
  const handleSingleReadNotification = useCallback(
    (id) => {
      dispatch(
        readSingleNotification({
          location_id: selectedLocation,
          notification_id: id,
        })
      )
        .then(() => {
          fetchNotificationList();
        })
        .catch((error) => {
          console.error("Error marking single notifications as read:", error);
        });
    },
    [dispatch, fetchNotificationList, selectedLocation]
  );
  return (
    <>
      <header>
        {(globalSearchLoading ||
          isLocationLoading ||
          patientBasicLoading ||
          permissionLocationWiseLoading ||
          patientLoading ||
          embryologyRedirect) && (
          <Spin tip="Loading" size="large">
            <div className="content" />
          </Spin>
        )}
        <Row className="align-items-center">
          <Col xs={2} xl={5} lg={4}>
            <div className="hedaer_left">
              <ul>
                <li>
                  <Button className="toggle_btn" onClick={toggleCollapsed}>
                    <img src={ToggleMenu} alt="" />
                  </Button>
                </li>
                <li className="d-none d-lg-block">
                  <div className="search_top">
                    <Select
                      showSearch
                      name="searchVal"
                      value={searchVal}
                      placeholder="Search anything here"
                      defaultActiveFirstOption={false}
                      suffixIcon={null}
                      filterOption={false}
                      onSearch={(e) =>
                        globalSearchTextChange(e, selectedLocation)
                      }
                      onChange={(e) => handleChange(e, data)}
                      notFoundContent={null}
                      options={(data || []).map((d) => ({
                        value: d?._id,
                        label: d?.patient_full_name,
                      }))}
                    />
                    {searchVal && (
                      <Button
                        className="clearIcon btn_transparent"
                        onClick={handleClearSearch}
                      >
                        <CloseOutlined />
                      </Button>
                    )}
                  </div>
                </li>
              </ul>
            </div>
          </Col>
          <Col className="d-block d-lg-none" xs={8}>
            <div className="page_heading">
              <h1>{getModuleName}</h1>
            </div>
          </Col>
          <Col xs={2} xl={7} lg={8}>
            <div className="right_header">
              <ul>
                {!UserPreferences.other && (
                  <li className="d-none d-lg-block">
                    <Button
                      type="button"
                      className="btn_transparent"
                      onClick={() => navigate("/patient-list")}
                    >
                      <img src={PatientIcon} className="patient_icon" alt="" />
                    </Button>
                  </li>
                )}
                <li className="position-relative">
                  <Button
                    type="button"
                    className="btn_transparent notification_btn"
                    onClick={() => setNotificationModal(true)}
                  >
                    <img src={NotificationIcon} alt="" />
                    {notificationList?.unreadCount && <span></span>}
                  </Button>
                  {notificationModal && (
                    <div className="notification_overlay">
                      <div className="overlay_top_wrap">
                        <h3>Notifications</h3>
                        <Button
                          className="btn_transparent"
                          onClick={() => setNotificationModal(false)}
                        >
                          <img src={Close} alt="" />
                        </Button>
                      </div>
                      <div className="notification_main_wrapper">
                        <div className="notification_top">
                          <Row>
                            <Col>
                              <h5>
                                All <span>{notificationList?.unreadCount}</span>
                              </h5>
                            </Col>
                            <Col className="text-end">
                              <Button
                                className="bg-transparent border-0 p-0 read_btn text_primary"
                                onClick={handleReadAllNotification}
                              >
                                Mark all as read
                              </Button>
                            </Col>
                          </Row>
                        </div>
                        <div className="notification_body">
                          {notificationList?.list?.map((notification) => {
                            const createdAtTime = moment(
                              notification?.created_at
                            ).fromNow();

                            return (
                              <div
                                className={`notification_box ${
                                  !notification.is_read ? "unread" : ""
                                }`}
                                onClick={() => {
                                  !notification?.is_read &&
                                    handleSingleReadNotification(
                                      notification?._id
                                    );
                                }}
                              >
                                <div className="notification_icon orange">
                                  <span>
                                    {notification?.user_name?.charAt(0)}
                                  </span>
                                </div>
                                <div className="notification_content">
                                  <h5>
                                    {notification.title} -{" "}
                                    {notification.message}
                                  </h5>
                                  <div className="d-flex justify-content-between">
                                    <p className="text_light m-0">
                                      <small>{createdAtTime}</small>
                                    </p>
                                    <p className="text_light m-0">
                                      <small>
                                        {formatDateToDDMMYYYY(
                                          notification.created_at
                                        )}
                                      </small>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                        <div className="notification_footer d-flex justify-content-end align-items-center">
                          <Button
                            className="btn_primary"
                            onClick={handleClearNotification}
                          >
                            Clear all notifications
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                </li>
                <li className="d-none d-lg-block">
                  <Button
                    type="button"
                    className="btn_transparent"
                    onClick={handleThemeChange}
                  >
                    {theme === "light" ? (
                      <img src={DarkIcon} className="dark_icon" alt="" />
                    ) : (
                      <img src={LightIcon} className="light_icon" alt="" />
                    )}
                  </Button>
                </li>
                {/* Notification Icon */}
                {/* <li>
                <Button className="btn_transparent btn_notification">
                  <img src={NotificationIcon} alt="" />
                  <span>8</span>
                </Button>
              </li> */}
                {/* Notification Icon */}
                <li className="d-none d-lg-block custom_select location_header">
                  <Select
                    placeholder="Select Location"
                    options={locationList}
                    value={selectLocation}
                    onChange={handleLocationChange}
                  />
                </li>
                {/* Language Change Dropdown */}
                {/* <li className="d-none d-lg-block">
                <Dropdown
                  menu={{
                    items: countryWiseLanguage,
                  }}
                  placement="bottomLeft"
                >
                  <Button className="language_dropdown">
                    <img src={UsFlag} className="me-2" alt="" /> English{" "}
                    <img src={SelectArrow} className="ms-2 down_arrow" alt="" />
                  </Button>
                </Dropdown>
              </li> */}
                {/* Language Change Dropdown */}
                <li className="d-none d-lg-block">
                  <Dropdown
                    menu={{
                      items: userDropDown,
                    }}
                    placement="bottomLeft"
                    className="user_dropdown"
                    trigger={["click"]}
                  >
                    <Button>
                      <span className="user_img me-2">
                        <div className="user_inner_text">
                          {UserPreferences?.user_name
                            ? `${UserPreferences?.user_name
                                ?.charAt(0)
                                ?.toUpperCase()}`
                            : "UN"}
                        </div>
                      </span>
                      {UserPreferences?.user_name}
                      <img
                        src={SelectArrow}
                        className="ms-2 down_arrow"
                        alt=""
                      />
                    </Button>
                  </Dropdown>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </header>

      {isShowChangePasswordModal && (
        <ChangePasswordModal
          isShowChangePasswordModal={isShowChangePasswordModal}
          setIsShowChangePasswordModal={setIsShowChangePasswordModal}
        />
      )}

      {notificationPermissionDialogVisible && (
        <NotificationPermissionDialog
          onClose={() =>
            dispatch(setNotificationPermissionDialogVisible(false))
          }
        />
      )}
    </>
  );
}
